import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import SelfCheckBox from '../Single Components/SelfCheckBox';
import '../../SelfOrderComponents/Components/Reports/mobileReports.css';


const LoginFormMobile = ({ onChangeFn,handleNextClick,clickLoginBtn, showForgotPassword, onForgotPasswordClick, loginLoading }) => {

  const { companyCode,userName,password } = useSelector((state) => state.loginFormNewSlice || {});
  const userRole = useSelector((state) => state.searchUserSlice.value);
  const [portableSelected, setPortableSelected] = useState(false);

  const handlePortableClick = () => {
    const newValue = !portableSelected;
    setPortableSelected(newValue);
    // Store in localStorage so LoginNew can check it after login
    if (newValue) {
      localStorage.setItem("portableMode", "true");
    } else {
      localStorage.removeItem("portableMode");
    }
  };

  const isNextEnabled=!(userName===null || userName==="" || companyCode===null || companyCode==="")

  return (
    <div className='login-new-main-left-container-mobile'>
      <div className="login-text-container">
        <Typography className="login-text-mobile">
          Login
        </Typography>
        <Typography className="login-description-mobile">
          Restaurant Innovative ERP Solutions.
        </Typography>
      </div>
      <div className="login-new-form-container-mobile">
        <div className="login-form" style={{position:"relative"}}>
        {userRole?.enableSelfOrd && <SelfCheckBox style={{top:"-45px"}}/>}
          <div className="user-name-container-mobile">

            {/* <p>Company Code</p> */}
            <div className="login-new-username-wrapper">
              <input
                placeholder='Company Code'
                className="right-input-login-user"
                type={"text"}
                name="companyCode"
                id="companyCodeInputMobile"
                value={companyCode || ""}
                onChange={onChangeFn}
                autoComplete="off"
              />
            </div>

            <div className="login-new-username-wrapper" style={{ position: 'relative' }}>
              <input
                className="right-input-login-user"
                placeholder='User Name'
                type={"text"}
                name="userName"
                id="userNameInputMobile"
                value={userName || ""}
                onChange={onChangeFn}
                autoComplete="off"
              />
              {/* Portable Button - shows only for admin users */}
              {userRole?.role === 'admin' && (
                <button 
                  className={`portable-btn ${portableSelected ? 'selected' : ''}`}
                  onClick={handlePortableClick}
                  type="button"
                >
                  Portable
                </button>
              )}
            </div>
            {userRole && (
                <>
                <div className="login-new-username-wrapper">
              <input
                className="right-input-login-user"
                placeholder='Password'
                type='password'
                name="password"
                id="passwordInputMobile"
                value={password || ""}
                onChange={onChangeFn}
                onKeyDown={(e) => {
                  e.key === "Enter" && clickLoginBtn();
                }}
              />

            </div>

            <button
              type="submit"
              // className="login-btn btn-hide"
              id="userNameNextBtn"
              className={password && !loginLoading ? "login-new-btn-mbl" : "login-btn-disabled"} 
              disabled={password === "" || loginLoading}
              onClick={clickLoginBtn}
            >
              {loginLoading ? 'Please wait…' : 'Login'}
            </button>
                </>
              )}
          </div>
          {!userRole && 
          <button
          disabled={!isNextEnabled} 
          type="submit" 
          onClick={handleNextClick}
          className={isNextEnabled?"login-new-btn-mbl":"login-btn-disabled"} 
          id="userNameNextBtn"
          >
            Next
          </button>
          }

          <div className="login-new-content-wrapper-forgot-password-register-mobile">
            <a href="https://eyeterp.com/" target="_blank" rel="noreferrer" style={{color:"#fff"}}>Register here !</a>
            {showForgotPassword && userRole && (
              <p 
                onClick={onForgotPasswordClick}
                style={{
                  cursor: 'pointer',
                  color: '#FF6B6B',
                  fontWeight: 'bold',
                  textDecoration: 'underline'
                }}
              >
                Forgot password? Click here
              </p>
            )}
            {!showForgotPassword && <p style={{opacity: 0.5}}> Forgot password &gt;&gt;&gt;</p>}
          </div>

        </div>
      </div>

    </div>
  )
}

export default LoginFormMobile